var $ = jQuery.noConflict();

$(window).on('load', function () {
    let method = 'front';
    if ($('body').hasClass('wp-admin'))
        method = 'wp-admin';

        var initializeBlock = function ($block) {

            $ (".block-accordions .accord-header").click (function (){
                // for active header definition
                $ ('.accord-header').removeClass ('open');
                $ (this).addClass ('open');

                // accordion actions
                if ($ (this).next ("div").is (":visible")) {
                    $ (this).next ("div").slideUp (200);
                    $ (this).removeClass ('open');
                } else {
                    $ (".accord-content").slideUp (200);
                    $ (this).next ("div").slideToggle (200);
                }
            });
    };

    window.onload = function () {
        initializeBlock($(this));
    }();

    if (window.acf) {
        window.acf.addAction('render_block_preview/type=accordions', initializeBlock);
    }
});
